export enum ParametersConstants {
  string = "string",
  null = "null",
  notNull = "notNull",
  date = "date",
  integer = "integer",
  decimal = "decimal",
  array = "array",
  object = "object",
  guid = "guid",
  any = "any"
}

export enum RequestParametersConstants {
  day = "day",
  dayInc = "day+1",
  deyDec = "day-1",
  month = "month",
  monthInc = "month+1",
  monthDec = "month-1",
  year = "year",
  yearInc = "year+1",
  yearDec = "year-1",
  uuid = "uuid",
  uniqueNumber = "uniqueNumber"
}
